module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv7-ea6094d255619631f8b5a3e9fb259367.jpg";